












































































































import Vue from 'vue';
import { NoteService } from '@/services/NoteService';
import { mapGetters } from 'vuex';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { confirmationHelper, TabsHelper } from '@/mixins';
import { NoteModel, NoteCreateModel, EntityType, TabStateModel, EVENT_BUS } from '@/types';
import { FormFieldValidation } from '@/mixins/formValidation';
import { EventBus } from '@/classes/EventBus';

export default Vue.extend({
  name: 'MStoreNarrativeTab',
  mixins: [FormFieldValidation, confirmationHelper, TabsHelper],
  props: {
    entityPK: {
      type: Number,
      required: true
    },
    entityType: {
      type: Number,
      default: EntityType.WorkflowJob
    },
    isLockAquired: {
      type: Boolean,
      default: false
    },
    cabinetId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false,
      isCreating: false,
      isEditing: false,
      subject: '',
      message: '',
      notes: {} as NoteModel[],
      isEditMode: false,
      currentEditNote: {} as NoteModel,
      isUserAdmin: false
    };
  },
  mounted() {
    this.getNotesAsync(this.entityPK);
    EventBus.$on(EVENT_BUS.RESET_TAB_DIRTY, () => this.onReset());
  },
  methods: {
    getNotesAsync(this: any, entityPk: number) {
      this.isLoading = true;
      NoteService.getNotesAsync(this.entityType, this.entityPK.toString(), this.cabinetId)
        .then((result: NoteModel[]) => {
          this.notes = result;
          this.$emit('tabItemCountChanged', {
            key: 'Narrative',
            itemCount: this.notesCount
          } as TabStateModel);
          this.handleTabsLoaded();
          this.isLoading = false;
        })
        .catch((reason: any) => {
          this.isLoading = false;
          return {} as NoteModel[];
        });
      this.isEditMode = false;
    },
    async createNoteAsync(entityPk: number) {
      this.isCreating = true;
      await NoteService.createNoteAsync(
        this.entityType,
        this.entityPK.toString(),
        {
          subject: this.subject,
          message: this.message
        } as NoteCreateModel,
        this.cabinetId
      ).catch((reason: any) => {
        this.isCreating = false;
      });
      this.isCreating = false;
      EventBus.$emit(EVENT_BUS.DOCUMENT_HISTORY_LOG_UPDATED, true);
    },
    async updateNoteAsync(entityPk: number, editNote: NoteModel) {
      this.isEditing = true;
      await NoteService.updateNoteAsync(
        this.entityType,
        this.entityPK.toString(),
        {
          subject: this.subject,
          message: this.message,
          id: editNote.id,
          userId: editNote.userId
        } as NoteModel,
        this.cabinetId
      ).catch((reason: any) => {
        this.isEditing = false;
      });
      this.isEditing = false;
      this.isEditMode = false;
      EventBus.$emit(EVENT_BUS.DOCUMENT_HISTORY_LOG_UPDATED, true);
    },
    async deleteNoteAsync(this: any, entityPk: number, deleteNoteId: number) {
      await this.hasDeleteConfirmedAsync(this.$bvModal, 'Are you sure you want to delete this note?').then(async (result: boolean) => {
        if (result) {
          await NoteService.deleteNoteAsync(this.entityType, this.entityPK.toString(), deleteNoteId, this.cabinetId)
            .then((result: any) => {
              this.getNotesAsync(this.entityPK);
            })
            .catch((reason: any) => {
              this.isEditing = false;
            });
        }
        this.setFieldsToEmpty();
      });
      EventBus.$emit(EVENT_BUS.DOCUMENT_HISTORY_LOG_UPDATED, true);
    },
    async onSubmit(this: any) {
      const isValid = await this.validateFormAsync('narrativeForm');
      if (isValid) {
        if (!this.isEditMode) {
          await this.createNoteAsync(this.entityPk);
        } else {
          await this.updateNoteAsync(this.entityPk, this.currentEditNote);
        }
        this.setFieldsToEmpty();
        this.$validator.reset();
        await this.getNotesAsync(this.entityPk);
      }
    },
    onReset() {
      this.setFieldsToEmpty();
      this.$validator.reset();
    },
    setFieldsToEmpty() {
      this.subject = '';
      this.message = '';
      if (this.currentEditNote) {
        this.currentEditNote = {} as NoteModel;
      }
      this.isEditMode = false;
      this.isEditing = false;
    },
    editNote(this: any, note: NoteModel) {
      this.isEditMode = true;
      this.subject = note.subject;
      this.message = note.message;
      this.currentEditNote = note;
      const subjectTextArea = this.$el.querySelector('#subject') as HTMLElement;
      if (subjectTextArea) {
        subjectTextArea.focus();
      }
    },
    async deleteNote(this: any, note: NoteModel) {
      this.onReset();
      this.currentEditNote = note;
      await this.deleteNoteAsync(this.entityPk, this.currentEditNote.id);
    }
  },

  watch: {
    isDirty(value: boolean) {
      this.$emit('tabIsDirtyChanged', {
        key: 'Narrative',
        isDirty: value
      } as TabStateModel);
    }
  },
  computed: {
    ...mapGetters('oidcStore', ['oidcUser']),
    ...mapGetters('userStore', ['isUserAdministrator']),
    notesCount(): number {
      if (!this.notes.length) {
        return 0;
      }
      return this.notes.length;
    },
    isDirty(this: any): boolean {
      return this.hasFormChanged();
    },
    isDisabled(this: any) {
      return (this.message === this.currentEditNote.message && this.subject === this.currentEditNote.subject) || this.isLoading || this.isCreating || this.errors.any();
    }
  },
  beforeDestroy() {
    EventBus.$off(EVENT_BUS.RESET_TAB_DIRTY);
  },
  components: {
    LoadingSpinner
  }
});
